/**
 * コードラベルマスタ キー区分定義
 */
// 曜日区分
export const KEY_CLASS_YOUBI_TYPE = '00001'
// 休日区分
export const KEY_CLASS_KYUJITSU_TYPE = '00002'
// 遅刻区分
export const KEY_CLASS_CHIKOKU_TYPE = '00003'
// 早退区分
export const KEY_CLASS_SOUTAI_TYPE = '00004'
// 業種コード
export const KEY_CLASS_GYOUSHU_CODE = '00005'
// 承認ステータス
export const KEY_CLASS_SHOUNIN_STATUS = '00006'
// 問い合わせ種別
export const KEY_CLASS_TOIAWASE_SHUBETSU = '00008'
// 結婚休暇オプション
export const KEY_CLASS_KEKKON_KYUKA_OPTION = '00009'
// 忌引き休暇オプション
export const KEY_CLASS_KIBIKI_KYUKA_OPTION = '00010'
// 勤務形態
export const KEY_CLASS_KINMU_KEITAI = '00011'
// 就業形態
export const KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE = '00012'

// /**
//  * 日付フォーマット
//  */
// // 年月日(WEB API向け)
// export const API_DAY_FORMAT = "YYYY-MM-DD";
// // 年月日 時分秒(WEB API向け)
// export const API_DAYTIME_FORMAT = "YYYY-MM-DD HH:mm:SS";
// // 年月日(画面表示)
// export const DISPLAY_DAY_FORMAT = "YYYY-MM-DD";
// // 年月日 時分秒(画面表示)
// export const DISPLAY_DAYTIME_FORMAT = "YYYY-MM-DD HH:mm:SS";
